import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import {Box} from "@mui/material";
import {withStyles} from "@mui/styles";

export default function CancelButton(props) {

    const {onConfirm, goal} = props

    const [open, setOpen] = React.useState(false);

    const StyledIconButton = withStyles((theme) => ({
        root: {
            '& svg': {
                color: theme.palette.custom.accent,
                background: theme.palette.custom.button,
                borderRadius:"80%"
            }
        },
    }))(IconButton);

    const handleClickOpen = (event) => {
        event.stopPropagation()
        setOpen(true);
    };

    const handleClose = (event) => {
        event.stopPropagation()
        setOpen(false);
    };

    const handleConfirm = (event) => {
        event.stopPropagation()
        setOpen(false);
        onConfirm()
    }

    return (
        <Box>
            <StyledIconButton onClick={handleClickOpen}>
                <CloseIcon fontSize="medium"/>
            </StyledIconButton>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"Cancel?"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Do you really want to cancel {goal}?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleConfirm} color="primary">
                        Confirm
                    </Button>
                    <Button onClick={handleClose} color="primary" autoFocus>
                        Go Back
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
}
